export interface ISampleSize {
    min: number;
    max: number;
}

export const instanceOfSampleSize = (value: any): value is ISampleSize => {
    return !value || Object.keys(value).some((x) => x === 'min');
};
